/* istanbul ignore file */
import React, { ReactNode } from 'react';
import { Transition, motion } from 'framer-motion';

const transition: Transition = {
  tween: {
    type: 'tween',
    duration: 0.5,
  },
};

const variants = {
  enter: {
    opacity: 1,
    transition: { delay: 1 },
  },
  exit: {
    opacity: 0,
  },
};

interface PanelMotionProps {
    children: ReactNode;
}

export default function PanelMotion({ children }: PanelMotionProps) {
    return <>{children}</>;
}
